const defaultApiEndPoint = document.defaultView.location.origin

export default {
  apiEndPoint: () => {
    if (defaultApiEndPoint.includes("localhost") || defaultApiEndPoint.includes("192.168")) {
      return `http://${document.defaultView.location.hostname}:6543`
    }
    try {
      if (window && window.localStorage) {
        const cfgData = window.localStorage.getItem("cb-config")
        if (cfgData) {
          return JSON.parse(cfgData).apiEndPoint
        }
      }
    } catch (err) {
      return defaultApiEndPoint
    }
    return defaultApiEndPoint
  },
  graphqlEndPoint: function () {
    return this.apiEndPoint() + "/graphql"
  },
  subscriptionEndPoint: () => {
    let wssUrl = ""
    if (window.location.hostname.includes("localhost") || window.location.hostname.includes("192.168")) {
      wssUrl = "ws://" + window.location.hostname + ":6543/graphql"
    } else if (window.location.hostname.includes("staging")) {
      wssUrl = "wss://" + window.location.hostname + "/graphql"
    } else {
      wssUrl = "wss://" + window.location.hostname + "/graphql"
    }
    console.log(`Based on ${window.location.hostname} -> connecting to ${wssUrl}`)
    return wssUrl
  },
  default: () => {
    return {
      apiEndPoint: defaultApiEndPoint.includes("localhost") ? "http://localhost:6543" : defaultApiEndPoint,
      graphqlEndPoint: defaultApiEndPoint.includes("localhost") ? "http://localhost:6543/graphql" : `${defaultApiEndPoint}/graphql`,
    }
  },
}
